import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { PAGES } from '../../utils/Constants';

class Nav extends Component {
  handleMobileClick = (e) => {
    //e.preventDefault();
    this.props.handleMobileClick(e);
  }
  render(){
    let mainNavClass = '';
    if(this.props.showMobileMenu){
      mainNavClass = 'show';
    }
    return(
      <nav>
        <ul className={`main-nav ${mainNavClass}`}>
          { PAGES.map((val, idx)=> (
            <li key={idx}>
              <NavLink onClick={this.handleMobileClick} to={val.link}>{val.name}</NavLink>
            </li>
          ))}
          
          <li className="social">
            <a href="https://www.facebook.com/Andyyeosings/" rel="noopener noreferrer" target="_blank"><i className="fa fa-facebook-official" aria-hidden="true"></i><span className="sr-only">Facebook</span></a>
          </li>
        </ul>
      </nav>
    );
  }
}
export default Nav;


// WEBPACK FOOTER //
// ./src/modules/sections/Nav.js